// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"addProductModal_btnContainer__2V8w3"};